import React from 'react'
import injectSheet from 'react-jss/lib/injectSheet'

const workThumbnail = {
  container: {
    width: '100%',
    height: '100%',
    overflow: 'hidden'
  },
  image: {
    boxShadow: '0 0 1em rgba(0, 0, 0, .05)',
    width: '100%',
    borderRadius: '.4em'
  }
}

const WorkSlideThumbnail = injectSheet(workThumbnail)(
  ({ classes, slide, onLoad }) => {
    const image =
      slide.work.media && slide.work.media[0] && slide.work.media[0].image_url
    return (
      <div className={classes.container}>
        <img
          onLoad={onLoad}
          className={classes.image}
          src={image}
          alt="Work exemplar"
        />
      </div>
    )
  }
)

export default WorkSlideThumbnail
